import React, { Component } from 'react';
import { FloatingLabel, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DBService from '../../service/DBService';
import PubSub from 'pubsub-js';
import { setCookie } from '../../service/Cookie';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      password: '',
      result: '',
      error: '',
      navigate: this.props.navigate,
      rememberMe: '',
      resendError: '',
      resendResult: ''
    };
  }

  validate = () => {
    let errorCount = 0, error = '';
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.userId)) {
      errorCount++;
      error = 'Invalid Email address (Example Email: abc@example.com)';
      this.setState({ 'error': error });
      return errorCount;
  
    }

    if (this.state.password.length < 8) {
      errorCount++;
      error = "Password should be minimum 8 characters (Example: uerY12#3)";
      this.setState({ 'error': error });
      return errorCount;
  
    }

    this.setState({ 'error': error });
    return errorCount;
  }

  signIn = () => {
    if (this.validate() === 0) {
      let body = {
        'userId': this.state.userId,
        'password': this.state.password
      }
      this.setState({ error: '', result: '' });
      DBService.userSignin(body)
        .then(result => {
          result = result.data;
          console.log('User signin', result);
          if (result !== undefined && result.length !== undefined && result.length <= 0) {
            this.setState({ error: 'Incorrect EmailId or password, please try again' });
          } else {
            if (result[0] !== undefined && result[0].isEmailVerified === 'No') {
              this.setState({ error: 'Please check your email inbox to validate', resendError: 'Please check your email inbox to validate' });
            } else if (result[0] !== undefined && result[0].isAccountLocked === 'Yes') {
              this.setState({ error: 'Sorry, your account is locked, please send an email to support@vizfm.com'});
            } else {
              result[0].password = this.state.password;
              //Remember me
              if (this.state.rememberMe) {
                setCookie(result[0], 365);
              } else {
                setCookie(result[0], 1);
              }

              this.setState({ result: 'Sign in success' });
              PubSub.publish('userLoggedIn', result[0]);
              this.state.navigate('/');
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ error: 'Error Signing in with EmailId, please try again' });
        });
    }
  }

  forgotPassword = () => {
    if (this.state.userId !== undefined) {
      let body = {
        'userId': this.state.userId,
      }
      DBService.userForgotPassword(body)
        .then(result => {
          result = result.data;
          console.log('Updated', result);
          this.setState({ error: '', result: 'An email has been sent out with the password, please check your email inbox' });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ 'error': 'Error sending email, please try again' });
        });
    }
  }

  onChangeRememberMe = (e) => {
    console.log('Remember me: ', e.target.checked);
    this.setState({ 'rememberMe': e.target.checked });
  }

  resendEmailConfirmation = () => {
    if (this.state.userId !== undefined) {
      this.setState({ 'resendError': '' });
      let body = {
        'userId': this.state.userId,
      }
      DBService.userVerifyUserid(body)
        .then(result => {
          result = result.data;
          console.log('Updated', result);
          if (result !== undefined && result.length !== undefined && result.length > 0) {
            this.setState({ 'resendResult': result, 'resendError': '' });
          } else {
            this.setState({ 'resendResult': '', 'resendError': 'UserId not found please signup again ' });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ 'resendResult': '', 'resendError': 'Error Signing in with EmailId, please try again' });
        });
    }
  }


  render() {
    return (
      <>
        <h4>VIZFM - Signin</h4>

        <FloatingLabel
          controlId="floatingInput"
          label="Email address"
          className="mb-3"
        >
          <Form.Control required type="email" placeholder="name@example.com" value={this.state.userId} onChange={e => this.setState({ userId: e.target.value })} />
        </FloatingLabel>

        <FloatingLabel controlId="floatingPassword" label="Password" className="mb-3">
          <Form.Control required type="password" placeholder="Password" value={this.state.password} onChange={e => this.setState({ password: e.target.value })} />
        </FloatingLabel>

        <Form>
          <Form.Check
            inline
            type='switch'
            id='1'
            label='Remember me'
            value={this.state.rememberMe}
            onChange={this.onChangeRememberMe}
          />
        </Form>

        {(this.state.result !== '') ? (
          <Alert key='primary' variant='success'>
            {this.state.result}
          </Alert>
        ) : <></>}
        {(this.state.error !== '') ? (
          <Alert key='danger' variant='danger'>
            {this.state.error}
          </Alert>

        ) : <></>}
        {(this.state.resendError !== '') ? (
          <>
            <Button variant="link" onClick={this.resendEmailConfirmation}>Resend Email</Button>
          </>
        ) : <></>}

        <p></p>
        <Button variant="primary" onClick={this.signIn}>Sign In</Button>{' '}
        <p></p>
        <Button variant="link" onClick={this.forgotPassword}>Forgot Password?</Button>
        <Link className="nav-link" to="/signup">Don't have an account?</Link>
      </>
    )
  }
}

export default SignIn;